(function() {
	function doSetup() {
		require('pie').setup();
		require('pie').runPie();
		require('pie').doBarAnimation(document.body);
	}

	if (document.readyState == 'complete') {
		setTimeout(doSetup, 0);
	} else {
		$(doSetup);
	}
})();
